export default "__VITE_ASSET__DlgDeVTH__"